module.exports = __webpack_public_path__ + "static/laptop_with_ems-23cd19fbe046858e30c43f3f94cb336c.svg";